import { Select, Tab, TabList, useBreakpointValue } from '@chakra-ui/react'
import { PROFILE_TABS } from '../utils/profileTabConfig'

interface ProfileTabNavigationProps {
  currentHash: string
  onHashChange: (hash: string) => void
}

const ProfileTabNavigation = ({
  currentHash,
  onHashChange,
}: ProfileTabNavigationProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false })

  if (isMobile) {
    return (
      <Select
        value={currentHash}
        onChange={(e) => onHashChange(e.target.value)}
        mb={4}
      >
        {PROFILE_TABS.map((tab, index) => (
          <option key={tab.hash} value={tab.hash}>
            {tab.label}
          </option>
        ))}
      </Select>
    )
  }

  return (
    <TabList>
      {PROFILE_TABS.map((tab) => (
        <Tab key={tab.hash} fontWeight='bold'>
          {tab.label}
        </Tab>
      ))}
    </TabList>
  )
}

export default ProfileTabNavigation
